<template>
  <div id="BlockChartBarLineBox">
    <c-block-box
      :title="title"
      class="margin-bottom-1rem"
    >
      <div class="num-pie--box">
        <div class="left">
          <div class="value">{{ options.activeRate }}</div>
          <div class="tendency">
            <!-- <div class="tendency-text">
                <span>周环比</span>
                <img :src="upsAndDowns(options.weekOpen.weekCountCompare)" />
                <em>{{ (options.weekOpen.weekCountCompare * 100).toFixed(2) }}%</em>
              </div> -->
            <div class="tendency-text">
              <span>同比</span>
              <img :src="upsAndDowns(options.activeRateCompare || '0')" />
              <em>{{ percentage(options.activeRateCompare || '0') }}%</em>
            </div>
            <div class="tendency-text">
              <span>环比</span>
              <img :src="upsAndDowns(options.rateCompare || '0')" />
              <em>{{ percentage(options.rateCompare || '0') }}%</em>
            </div>
          </div>
          <div class="target-rate">
            <c-target-rate
              label="目标"
              :target="`${options.activeRateTarget}`"
              :is-progress="false"
              class="target-item"
            >
            </c-target-rate>
            <c-target-rate
              label="完成率"
              :num="percentage(options.activeRateTargetRate || '0')"
            >
            </c-target-rate>
            <slot name="bot">
            </slot>
          </div>
        </div>
        <div class="right">
          <ChartBarLine
            :id="chartId"
            height="11.9rem"
            v-if="ChartBarLineShow"
            :option="ChartBarLine"
          ></ChartBarLine>
        </div>
      </div>
      <template slot="sub-title">
        <slot name="blockSubTitle"></slot>
      </template>
    </c-block-box>
  </div>
</template>

<script>
import ChartBarLine from '@/components/echarts/line2'
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  name: 'BlockChartBarLineBox',
  components: {
    ChartBarLine
  },
  props: {
    options: {},
    data: {},
    title: {},
    yAxisMin: {
      default: 0
    }
  },
  data () {
    return {
      ChartBarLine: {},
      ChartBarLineShow: false,
      chartId: new Date().getTime() + '' + parseInt(Math.random() * 10000)
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {
    'data': {
      handler: function (newValue) {
        if (Object.keys(newValue).length < 1) { return }
        let val = JSON.parse(JSON.stringify(newValue))
        let icon = val.yAxis && val.yAxis.name
        delete val.yAxis
        this.lineFormatData(val, [icon])
      }
    }
  },
  methods: {
    lineFormatData (data, yKey, type) {
      const isAndroid = this.$store.state.app.isAndroid
      const keys = Object.keys(data)
      let minValueArr = []
      keys.forEach((item) => {
        minValueArr.push(this.mathMin(data[item].data))
      })
      const minValue = this.mathMin(minValueArr)
      let xData = []
      if (data[keys[0]] && data[keys[0]].data) {
        xData = data[keys[0]].date.map(item => {
          return this.$cUtils.format.formatDate(item, 'MM-dd')
        })
      }
      const option = {
        config: {
          xData: xData,
          splitNumber: 2,
          legend: {
            top: !isAndroid ? 20 : 10,
            right: 10
          },
          grid: {
            top: 45,
            right: 10,
            bottom: 10
          },
          yAxis: []
        },
        data: []
      }
      const yAxis = {
        name: yKey[0],
        type: 'value',
        splitLine: {
          lineStyle: {
            color: 'rgba(255,255,255,0.1)'
          }
        },
        // min: minValue,
        min: this.yAxisMin,
        axisLine: {
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: 'rgba(255,255,255,.6)',
            fontSize: !isAndroid ? 12 : 10
          },
          formatter: function (value, index) {
            return value | 0
          }
        },
        nameTextStyle: {
          color: '#999',
          fontSize: !isAndroid ? 12 : 10
        },
        splitNumber: 3
      }
      option.config.yAxis.push(yAxis)
      if (yKey.length > 1 && !!yKey[1]) {
        const copyYAxis = JSON.parse(JSON.stringify(yAxis))
        this.$set(copyYAxis, 'name', yKey[1])
        option.config.yAxis.push(copyYAxis)
      }
      keys.forEach(item => {
        const itemData = {
          name: item,
          data: data[item].data,
          symbol: 'none',
          lineStyle: {
            type: item === '目标' ? 'dashed' : 'solid',
            width: !isAndroid ? 2 : 0.5
          },
          type: 'line',
          smooth: true,
          yAxisIndex: item === '活跃率' ? 1 : 0
        }
        if (type && item !== '目标') {
          this.$set(itemData, 'areaStyle', {})
          this.$set(itemData, 'stack', '总量')
        }
        option.data.push(itemData)
      })
      this.ChartBarLine = option
      this.ChartBarLineShow = true
    }
  }
}
</script>

<style scoped lang="stylus">
#BlockChartBarLineBox
  color: #fff
  >>>
    .c-progress
      margin-top: 0
  >>>
    .c-target-rate
      line-height: inherit
.tendency
  .tendency-text
    font-size: .6rem
    margin-bottom: .5rem
  img
    width .4rem
.num-pie--box
  display: flex
  padding: .5rem .8rem
  .right
    width 100%
.left
  .value
    line-height 4rem
    font-size 2.6rem
    color #fff
.target-item
  margin-bottom: .5rem
.left
 .value
  line-height: 3rem
</style>
